import React, { useEffect } from 'react'
import { getActiveLayers, removeActiveTool, selectActiveLayer, setActiveLayer } from '../../../../../../../redux/toolsSlice';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getActiveStep } from '../../../../../../../redux/toolsSlice';
import { getLayerObjConfig, removeLayerConfig, setLayerConfig, updateLayer } from '../../../../../../../redux/stepsSlice';
import EditorPreviewEmbed from '../../../../../walkthroughs/EditorPreviewEmbed';
import { getMaterial } from '../../../../../../../redux/materialSlice';
 
export const walkthroughLayerDefaults = (id) => {
  return {
    id: id,
    type: 'walkthrough',
    material_id: ''
  };
}

function WalkthroughContent({ layer }) {
  const dispatch = useDispatch();
  const layerObjConfig = useSelector(
    (state) => getLayerObjConfig(state, layer),
    shallowEqual
  );
  const activeStep = useSelector((state) => getActiveStep(state));
  const stepId = activeStep.id;
  const activeLayer = useSelector((state) => selectActiveLayer(state));
  const material = useSelector((state) => getMaterial(state));
  const defaultConfig = [
    {
      layerId: layer.id,
      sectionId: 'walkthrough',
      sectionTitle: 'Walkthrough Element',
      values: [
        {
          id: 'source',
          title: 'Select a Walkthrough from the list below',
          type: 'walkthrough-select',
          value: layer.source || "",
          direction: 'column'
        }
      ]
    }
  ];
  
  const editElement  = () => {
    dispatch(setActiveLayer(layer));
    dispatch(setLayerConfig(defaultConfig));
  }

  const removeFocusElement = () => {
    dispatch(setActiveLayer({}));
    dispatch(removeLayerConfig());
  }

  useEffect(() => {
    if (stepId && Object.keys(layerObjConfig || {}).length > 0) {
      const newLayer = {
        ...layer,
        ...layerObjConfig
      };
      dispatch(updateLayer({ stepId: stepId, layer: newLayer }));
    }
  }, [layerObjConfig]);
  
  return (
    <div className='wk-wrapper'>
      {layer.source ?
        <div onClick={editElement}>
          <EditorPreviewEmbed id={layer.source} parent_visibility={material.visibility} />
          {/* {activeLayer && activeLayer.id == layer.id && 
            <button className='btn btn-primary save-btn' onClick={removeFocusElement}>Save</button>
          } */}
        </div>
      :
        <div className="un-pe-drop" tabIndex={0} onClick={editElement}>
          <span className="un-pe-drop__i">
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none"><path d="M12 8c2.4 0 4 .3 4.3 1.4C17 11 17.5 12.6 18 14c.3 1 .6 2.4.8 3.6H4c.4-1.8.9-3.7 1.4-5.6.3-1.2.6-3 2.3-3" stroke="#028496" strokeWidth="1.1" /></svg>
          </span>
          <div className="un-pe-drop__t">Select a walkthrough to embed</div>
          <span className="un-pe-drop__btn">
            Choose walkthrough
            <svg width="12" height="12" viewBox="0 0 20 20" fill="none"><path d="M6.53 7.7 10 11.2l3.47-3.5" stroke="#9AA6AE" strokeWidth="1.6" strokeLinecap="round" /></svg>
          </span>
        </div>
      }
    </div>
  )
}

export default WalkthroughContent
